import { render } from "./YearMaster.vue?vue&type=template&id=4695fb05&scoped=true"
import script from "./YearMaster.vue?vue&type=script&lang=js"
export * from "./YearMaster.vue?vue&type=script&lang=js"

import "./YearMaster.vue?vue&type=style&index=0&id=4695fb05&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4695fb05"]])

export default __exports__